<template>
  <div>
    <div
        v-if="loading"
        class="spinner-loader"
    >
      <sync-loader/>
      <p>Loading ...</p>
    </div>
    <div
        v-if="!loading && member"
        class="modal-box"
    >
      <header class="modal-card-head">
        <span class="modal-card-title">Edit member</span>
        <!--<button @click="close" class="delete" aria-label="close"></button>-->
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">First Name</label>
              <p class="control">
                <input
                    v-model="member.first"
                    class="input"
                    type="text"
                    placeholder="First"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Middle Name</label>
              <p class="control">
                <input
                    v-model="member.middle"
                    class="input"
                    type="text"
                    placeholder="Middle"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Last Name</label>
              <p class="control">
                <input
                    v-model="member.last"
                    class="input"
                    type="text"
                    placeholder="Last"
                >
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">AHL ID</label>
              <p class="control">
                <input
                    v-model="member.ahlid"
                    disabled
                    class="input"
                    type="text"
                    placeholder="AHL ID"
                >
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Poker Nickname</label>
              <p class="control">
                <input
                    v-model="member.handle"
                    class="input"
                    type="text"
                    placeholder="Poker Nickname"
                >
              </p>
            </div>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">E Mail</label>
              <p class="control">
                <input
                    v-model="member.email"
                    class="input"
                    type="text"
                    placeholder="Email"
                >
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Phone</label>
              <p class="control">
                <input
                    v-model="member.phone"
                    class="input"
                    type="text"
                    placeholder="Phone"
                >
              </p>
            </div>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Password</label>
              <p class="control">
                <input
                    v-model="member.password"
                    class="input"
                    type="password"
                    placeholder="Password"
                >
              </p>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Confirm Password</label>
              <p class="control">
                <input
                    v-model="member.confirm"
                    class="input"
                    type="password"
                    placeholder="Confirm Password"
                >
              </p>
            </div>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-12">
            <div class="field">
              <label class="label">Street</label>
              <p class="control">
                <input
                    v-model="member.address"
                    class="input"
                    type="text"
                    placeholder="Full Address"
                >
              </p>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">City</label>
              <p class="control">
                <input
                    v-model="member.city"
                    class="input"
                    type="text"
                    placeholder="City"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">State</label>
              <p class="control">
                <input
                    v-model="member.state"
                    class="input"
                    type="text"
                    placeholder="State"
                >
              </p>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">ZIP</label>
              <p class="control">
                <input
                    v-model="member.zip"
                    class="input"
                    type="text"
                    placeholder="ZIP"
                >
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="modal-card-body" v-if="canBonus">
        <div class="columns">
          <div class="column is-12"><h1>Bonuses</h1></div>
        </div>
        <div class="columns">
          <div class="column is-6" v-for="(bonus,index) in member.bonuses" :key="index">
            <div class="field">
              <p class="control">
                <input
                    v-model="member.bonuses[index].active"
                    :checked="bonus.active"
                    type="checkbox"
                >&nbsp;&nbsp;<b>{{ bonus.name }}</b>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="modal-card-body" v-if="canStars">
        <div class="columns">
          <div class="column is-12"><h1>AHL Stars:</h1></div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              Add Stars for this month:
              <p class="control">
                <input
                    v-model="member.stars"/>
              </p>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a
            class="button button-tools"
            @click.prevent="edit"
        >Save changes</a>
        <a
            class="button"
            @click.prevent="close"
        >Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdmitEditMember',
  components: {},
  props: ['token'],
  data() {
    return {
      canBonus: false,
      canStars: false,
      loading: false,
      member: null,
    }
  },
  mounted() {
    this.loading = true
    this.$axios({
      method: 'POST',
      url: `admin/members/getmember`,
      headers: {
        Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      data: {
        token: this.token || '',
        ahlid: this.$route.params.ahlid
      }
    })
        .then((res) => {
          this.loading = false
          if (res.data.error) {
            this.$emit('message',
                {
                  showDialog: true,
                  error: res.data.error,
                  message: res.data.message
                })
            return;
          }
          this.member = res.data.member
          this.canBonus = res.data.canBonus
          this.canStars = res.data.canStars
        })
        .catch((error) => {
          this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          this.loading = false
        })
  },
  methods: {
    edit() {
      this.$emit('edit', this.member)
    },
    close() {
      this.$router.push('/admin/ahl-members')
    }
  }
}
</script>
